<div class="m-2 w-80 text-center">
  <table class="table-auto">
    <tbody>
      <tr>
        <td>ArticleId:</td>
        <td>{{ selectedOrder?.articleId }}</td>
      </tr>
      <tr>
        <td>Creation Date:</td>
        <td>{{ selectedOrder?.creationDate }}</td>
      </tr>
      <tr>
        <td>Batch Id:</td>
        <td>{{ selectedOrder?.batchId }}</td>
      </tr>
      <tr>
        <td>Transport Order Nr:</td>
        <td>{{ selectedOrder?.customerOrderNumber }}</td>
      </tr>
      <tr>
        <td>Delivery Note Id:</td>
        <td>{{ selectedOrder?.deliveryNoteId }}</td>
      </tr>
      <tr>
        <td>Company Code:</td>
        <td>{{ selectedOrder?.companyCode }}</td>
      </tr>
    </tbody>
  </table>
</div>

<div class="m-5 flex justify-center">
  <fip-button
    label="Delivery"
    backgroundColor="black"
    textColor="white"
    classes="px-3 py-2 sm:ml-3 sm:mt-0 sm:w-auto shadow-sm text-sm"
    (clickEvent)="goToDeliveries()"
  ></fip-button>
</div>
